import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

export type InterfaceKebabInteractionOption =
  | "change_owner"
  | "delete"
  | "duplicate"
  | "rename"
  | "move"
  | "share";

export function useEmitInterfaceKebabInteractionEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (optionSelected: InterfaceKebabInteractionOption, interfaceId?: string) => {
      emitUserInteractionEvent({
        accountId,
        interactionName: UserInteractionName.InterfaceKebab,
        optionSelected,
        customTrackingFields: {
          interface_id: interfaceId,
        },
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
